// extracted by mini-css-extract-plugin
export default {"footerNavigation":"FooterNavigation_footerNavigation__Tsfl8","menuItem":"FooterNavigation_menuItem__faxG1"};